import Loader from "@components/Loader";
import { UPDATE_PASSWORD } from "@constants/routes";
import FormField from "@easydev/form/FormField";
import EditIcon from "mdi-react/EditIcon";
import { Field, Form } from "react-final-form";
import { Link } from "react-router-dom";
import { Button, ButtonToolbar, Card, CardBody, Col, Row } from "reactstrap";

const ProfileSettings = ({
  onSubmit,
  validateForms,
  profile,
  isLoading,
  isLoadingUpdate,
}) => (
  <Col xs={12} md={12} lg={12} xl={8}>
    <Card>
      <CardBody>
        {isLoading ? (
          <Loader isInsideThing />
        ) : (
          <>
            <Row>
              <Col md={12}>
                <h4 className="page-title">
                  <EditIcon />
                  Edit personal information
                </h4>
              </Col>
            </Row>
            <Form
              onSubmit={(FormValues) => {
                onSubmit(FormValues);
              }}
              validate={validateForms}
            >
              {({ handleSubmit }) => (
                <form className="form form--horizontal" onSubmit={handleSubmit}>
                  <div className="form__form-group">
                    <span className="form__form-group-label">{"Mail"}</span>
                    <div className="form__form-group-field">
                      <Field
                        name="email"
                        component="input"
                        type="email"
                        placeholder={profile?.mail}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="form__form-group">
                    <span className="form__form-group-label">{"Username"}</span>
                    <div className="form__form-group-field">
                      <Field
                        name="username"
                        component={FormField}
                        type="text"
                        initialValue={profile?.username}
                        isAboveError
                      />
                    </div>
                  </div>

                  <div className="form__form-group">
                    <span className="form__form-group-label">{"Name"}</span>
                    <div className="form__form-group-field">
                      <Field
                        name="name"
                        component={FormField}
                        type="text"
                        initialValue={profile?.name}
                        isAboveError
                      />
                    </div>
                  </div>

                  <div className="form__form-group">
                    <span className="form__form-group-label">
                      {"Last name"}
                    </span>
                    <div className="form__form-group-field">
                      <Field
                        name="lastname"
                        component={FormField}
                        type="text"
                        initialValue={profile?.lastname}
                        isAboveError
                      />
                    </div>
                  </div>

                  {isLoadingUpdate ? (
                    <Loader isInsideThing />
                  ) : (
                    <ButtonToolbar className="form__button-toolbar">
                      <Link to={UPDATE_PASSWORD}>
                        <Button color="primary" type="submit" outline>
                          Modify Password
                        </Button>
                      </Link>
                      <Button color="success" type="submit">
                        Modify Profile
                      </Button>
                    </ButtonToolbar>
                  )}
                </form>
              )}
            </Form>
          </>
        )}
      </CardBody>
    </Card>
  </Col>
);

export default ProfileSettings;
